var initialState = {
  ui: {
    isRequesting: false
  },
  data: {
    userId: 'wishlist-localList',
    wishlists: [{
      wid: 'wishlist-localList',
      name: 'Your Wishlist',
      items: []
    }]
  },
  error: null
};
export default initialState;